import type { RadioButtonGroupProps } from '@sunwebgroup/uds-ui/radio-button'
import { RadioButtonGroup } from '@sunwebgroup/uds-ui/radio-button'
import cn from 'classnames'
import styles from './Column.module.css'

export function Column({ className, ...props }: RadioButtonGroupProps) {
  return <RadioButtonGroup className={cn(styles.column, className)} {...props} />
}
